import {
  addCode,
  addDocument,
  addSegment,
  emptyProject,
  type Project,
} from "@/lib/tool-kit/qualitative-text/coding";

export interface SampleSpec {
  title: string;
  text: string;
  /** Codes in creation order; `parent` is another entry's `key`. */
  codes: readonly { key: string; name: string; parent?: string }[];
  /** Passages as the exact words to find in `text`. */
  passages: readonly { code: string; quote: string }[];
}

/** Build a ready-coded project from a sample specification. */
export function buildSampleProject(spec: SampleSpec): Project {
  const added = addDocument(emptyProject(), spec.title, spec.text);
  let project = added.project;
  const ids = new Map<string, string>();
  for (const code of spec.codes) {
    const parent = code.parent ? (ids.get(code.parent) ?? null) : null;
    const next = addCode(project, code.name, parent);
    project = next.project;
    if (next.id) {
      ids.set(code.key, next.id);
    }
  }
  for (const passage of spec.passages) {
    const start = spec.text.indexOf(passage.quote);
    const codeId = ids.get(passage.code);
    if (start >= 0 && codeId) {
      project = addSegment(
        project,
        added.id,
        start,
        start + passage.quote.length,
        codeId
      );
    }
  }
  return project;
}
